export default "__VITE_ASSET__DrORkrcp__"